import Block from './Block'
import store from '../store'
import gsap from 'gsap'
import Mousemove from '../util/Mousemove'

export default class HomeCover extends Block {
  init() {
    this.inView = false

    this.mouse = {
      target: {
        x: 0,
        y: 0
      },
      current: {
        x: 0,
        y: 0
      }
    }

    this.mm = new Mousemove({
      cb: this.move,
      el: this.el
    })

    !store.isMobile && this.set()

    gsap.set(this.$background, { yPercent: 101 })
    gsap.set(this.$video, { opacity: 0 })

  }

  onEnterCompleted() {
    !store.isMobile && this.observer()
    this.animate().then(() => !store.isMobile && this.mm.on())

    this.createTimelines()
  }

  destroy() {
    !store.isMobile && this.mm.off()
  }

  bindMethods() {
    this.move = this.move.bind(this)
  }

  getElems() {
    this.$wrapperVideo = this.el.querySelector('.c-home-cover__long-video')
    this.$overlay = this.el.querySelector('.c-home-cover__overlay')
    this.$background = this.el.querySelector('.c-home-cover__long-video-bg')
    this.$video = this.el.querySelector('.c-home-cover__long-video video')
    this.$source = this.el.querySelector('.c-home-cover__long-video source')
    this.$video_short = this.el.querySelector('.c-home-cover__video video')
    this.$cross = this.el.querySelector('.cross')
    this.$cta = this.el.querySelector('.c-home-cover__cta')

    this.items = []

    this.$images = this.el.querySelectorAll('.c-home-cover__image')

    for (let i = 0; i < this.$images.length; i++) {
      this.items.push({
        el: this.$images[i],
        offset: this.$images[i].dataset.offset,
        translate: {
          x: 0,
          y: 0
        }
      })
    }
  }

  events() {
    if (this.$video) {
      this.$cta.addEventListener('click', this.open.bind(this))
      this.$cross.addEventListener('click', this.close.bind(this))
    }
  }

  createTimelines() {
    this.openTl = gsap.timeline({ paused: true })

    this.openTl
      .addLabel('start', 0)
      .to(this.$background, {
        yPercent: 0,
        ease: 'power4.out',
        duration: 0.4,
        onStart: () => {
          this.$overlay.classList.add('show')
          // gsap.to(this.$header, { opacity: 0 })
        },
        onComplete: () => {
          gsap.set(this.$video, { opacity: 1 })
          gsap.set(this.$wrapperVideo, { backgroundColor: 'black' })
        }
      }, 'start')
      .to(this.$background, {
        yPercent: -101,
        ease: 'power4.out',
        duration: 0.4,
        onComplete: () => {
          if (this.$video_short) {
            this.$video_short.pause()
          }

          this.$wrapperVideo.style.pointerEvents = 'all'
          this.$cross.classList.remove('hidden')
        }
      })
      .set(this.$cta, { pointerEvents: 'none' })

    this.closeTl = gsap.timeline({ paused: true })

    this.closeTl
      .addLabel('start', 0)
      .to(this.$background, {
        yPercent: 0,
        ease: 'power4.out',
        duration: 0.4,
        onStart: () => {
          this.$overlay.classList.remove('show')
          this.$wrapperVideo.style.pointerEvents = 'none'

          if (this.$video_short) {
            this.$video_short.play()
          }

          this.$cross.classList.add('hidden')
        },
        onComplete: () => {
          gsap.set(this.$video, { opacity: 0 })
          gsap.set(this.$wrapperVideo, { backgroundColor: 'transparent' })
          // gsap.to(this.$header, { opacity: 1 })
        }
      }, 'start')
      .to(this.$background, {
        yPercent: 101,
        ease: 'power4.out',
        duration: 0.4
      })
      .set(this.$cta, { pointerEvents: 'all' })
  }

  open() {
    this.$video.play()
    this.openTl.invalidate()
    this.openTl.restart()
  }

  close() {
    this.$video.pause()
    this.closeTl.invalidate()
    this.closeTl.restart()
  }


  set() {
    this.wrapperTop = this.el.getBoundingClientRect().bottom

    for (let i = 0; i < this.items.length; i++) {
      const { el } = this.items[i]
      const { top } = el.getBoundingClientRect()

      gsap.set(el, { y: this.wrapperTop - top + 100 })
    }
  }

  animate() {
    return new Promise((resolve) => {
      const title = this.el.querySelectorAll('.title .line')
      const suptitle = this.el.querySelector('.suptitle span')
      const buttons = this.el.querySelectorAll('.c-home-cover__button')

      gsap.to(title, {
        y: 0,
        rotate: 0,
        stagger: 0.1,
        ease: 'expo.out',
        duration: 1
      })

      gsap.to(suptitle, {
        y: 0,
        ease: 'expo.out',
        duration: 1
      })

      gsap.to(buttons, {
        y: 0,
        opacity: 1,
        delay: 0.5,
        ease: 'expo.out',
        stagger: 0.1,
        duration: 1
      })

      gsap.to(this.$images, {
        y: 0,
        delay: 0.25,
        stagger: 0.1,
        ease: 'expo.out',
        duration: 1.3,
        onComplete: () => resolve()
      })
    })
  }

  observer() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.inView = entry.isIntersecting
      })
    })

    observer.observe(this.el)
  }

  move(x, y) {
    this.mouse.target = {
      x,
      y
    }
  }

  map(x, a, b, c, d) {
    return (x - a) * (d - c) / (b - a) + c
  }

  lerp(a, b, n) {
    return (1 - n) * a + n * b
  }

  update() {
    if (!this.inView || store.isMobile) return

    const { target, current } = this.mouse

    this.needU = Math.round(current.x) !== target.x || Math.round(current.y) !== target.y

    if (!this.needU) return

    current.x = this.lerp(current.x, target.x, 0.09)
    current.y = this.lerp(current.y, target.y, 0.09)

    for (let i = 0; i < this.items.length; i++) {
      const { translate, el, offset } = this.items[i]

      translate.x = this.lerp(translate.x, this.map(target.x, 0, store.w.ww, -offset, offset), 0.09)
      translate.y = this.lerp(translate.y, this.map(target.y, 0, store.w.wh, -offset, offset), 0.09)

      el.style.transform = `translate3d(${translate.x}px, ${translate.y}px, 0)`
    }
  }
}
